module.exports = __webpack_public_path__ + "static/flowers-6a8c448a989cedfb0e743ee9626d8796.png";